import { IconProps } from "../types";

export const PngIcon = ({ src, width, height, className }: IconProps) => (
  <img src={`/img/png/${src}`} className={className} alt={src} width={width} height={height} />
);
